module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('banet-modal-confirm', {
    attrs: {
      "show": _vm.showConfirm,
      "showFooter": true,
      "title": _vm.getTranslation('modal_confirm_title'),
      "body": _vm.getTranslation('label_confirm_translation_deleting')
    },
    on: {
      "confirmNo": function($event) {
        _vm.confirm(false)
      },
      "confirmYes": function($event) {
        _vm.confirm(true)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('h2', [_vm._v(_vm._s(_vm.getTranslation('translation_create_headline')))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.getTranslation('translation_create_input_key')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.translation.key),
      expression: "translation.key"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.translation.key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.translation.key = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.getTranslation('translation_create_input_label_english')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.translation.en),
      expression: "translation.en"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.translation.en)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.translation.en = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.getTranslation('translation_create_input_label_german')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.translation.de),
      expression: "translation.de"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.translation.de)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.translation.de = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.getTranslation('button_label_submit')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4735ccef!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App/public/components/translations/Translation.vue
// module id = 676
// module chunks = 0